import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

// SPEC-101 D9: /login/otp became a step of /login (email first, then a code
// or a password). Keep the route for old links and the SPEC-041 hand-offs:
// the email and the return path (`next`) travel on in route state.
export default function OtpLoginRedirect() {
  const { state } = useLocation()
  return <Navigate to="/login" replace state={state} />
}
